
export class ManageLocationsModel {
  businessPoolUuid: string;
  locationUuid: string;
  mode: string;
}

export class ManageConflicts {
  static readonly type = '[Manage Locations] Enter conflicts mode for a specific business pool and public location uuid';
  constructor(public payload: { locationUuid: string, businessPoolUuid: string }) {}
}
export class ManageVersions {
  static readonly type = '[Manage Locations] Enter Versions mode for a specific business pool and public location uuid';
  constructor(public payload: { locationUuid: string, businessPoolUuid: string }) {}
}

export class ManageHistory {
  static readonly type = '[Manage Locations] Enter historical versioning mode for a specific business pool and public location uuid';
  constructor(public payload: { businessPoolUuid: string, locationUuid: string }) {}
}
export class ExitConflicts {
  static readonly type = '[Manage Locations] Exit conflicts mode for a specific business pool and public location uuid';
}

export class ExitHistory {
  static readonly type = '[Manage Locations] Go back to managing locations for a specific business pool uuid';
}

export class ExitBusinessPool {
  static readonly type = '[Manage Locations] Remove business pool filter on location uuid';
}

export class FilterLocations {
  static readonly type = '[Manage Locations] filter locations by business pool'
  constructor(public payload: { businessPoolUuid: string }) {}
}
